import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-unavailable',
  templateUrl: './unavailable.component.html',
  styleUrls: ['./unavailable.component.sass'],
})
export class UnavailableComponent implements OnInit {
  constructor(private router: Router) {
    /** */
  }

  ngOnInit(): void {
    /** */
  }

  /**
   * retry to connect
   */
  retry(): void {
    this.router.navigate(['/page/login']);
  }
}
